import { useQuery } from 'react-query';

import Api from '../../api/api';

export type ReportedUsersDto = {
  page?: number;
  limit?: number;
  sort?: string;
  search?: string;
};

const reportedUsers = async (params: ReportedUsersDto) => {
  const [response, bodyOrError] = await Api.get(`reports/reported-users`, params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

const useGetAllReportedUsers = (params: ReportedUsersDto) => {
  return useQuery({
    queryKey: ['reportedUsers', params],
    queryFn: () => reportedUsers(params),
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
};

export default useGetAllReportedUsers;
